import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  InputAdornment,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UserTopbar from "../UserTopbar";
import { useNavigate, useOutletContext } from "react-router-dom";
import UserSection from "../../Services/User/UserLogin";
import Swal from "sweetalert2";
import { deleteDraft } from "../../redux/slices/draftSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../utils/Loader";
import { fetchUserProduct } from "../../redux/slices/productSlice";
import { Select as MuiSelect } from "@mui/material";
import Select from "react-select";
import UserService from "../../Services/UserList";
import { Search } from "lucide-react";
import { FaSearch } from "react-icons/fa";
import Apiurl from "../../Helpers/apiUrl";

const UserProducts = () => {
  const { isSidebarOpen } = useOutletContext();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedFinish, setSelectedFinish] = useState(null);
  const [selectedSpare, setSelectedSpare] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [group, setGroup] = useState([]);
  const [collection, setCollection] = useState([]);
  const [spare, setSpare] = useState([]);
  const [finish, setFinish] = useState([]);
  const [loading, setLoading] = useState(false);

  const { adminProducts, count, getStatus } = useSelector(
    (state) => state.product
  );
  const counts = count || 0;

  useEffect(() => {
    dispatch(
      fetchUserProduct({
        page: page,
        rowsPerPage: rowsPerPage,
        search: searchQuery,
        brand: selectedBrand ? selectedBrand.value : null,
        finish: selectedFinish ? selectedFinish.value : null,
        spare_fg: selectedSpare ? selectedSpare.value : null,
        product_typ_group: selectedGroup ? selectedGroup.value : null,
        collection: selectedCollection ? selectedCollection.value : null,
      })
    );
  }, [
    page,
    rowsPerPage,
    searchQuery,
    selectedBrand,
    selectedFinish,
    selectedSpare,
    selectedGroup,
    selectedCollection,
  ]);

  const brandOpt = [
    { value: "GROHE", label: "GROHE" },
    { value: "AS", label: "AMERICAN STANDARD" },
  ];

  useEffect(() => {
    productSpareApi();
    productGrouptApi();
    productCollectionApi();
    productFinsiApi();
  }, []);


  const fallbackImg = Apiurl ? Apiurl.replace('/api/', '/img/no_image.jpeg') : '/img/no_image.jpeg';

  // group
  const productGrouptApi = async () => {
    try {
      const response = await UserService.group();
      if (response && response.data) {
        setGroup(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch product groups:", error);
    }
  };

  const productCollectionApi = async () => {
    try {
      const response = await UserService.collection();
      if (response && response.data) {
        setCollection(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch product collections:", error);
    }
  };

  // spare
  const productSpareApi = async () => {
    try {
      const response = await UserService.spare();
      if (response && response.data) {
        setSpare(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch product spares:", error);
    }
  };

  const productFinsiApi = async () => {
    try {
      const response = await UserService.finish();
      if (response && response.data) {
        setFinish(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch product finishes:", error);
    }
  };

  const collectionOpt = collection
    ? collection.map((item) => {
        const val = typeof item === 'string' ? item : (item.name || item.collection || '');
        return { value: val, label: val };
      })
    : [];
  const finishOption = finish ? finish.map((item) => (typeof item === 'string' ? item : (item.name || item.finish || ''))) : [];
  const finishOpt = finish
    ? finish.map((item) => {
        const val = typeof item === 'string' ? item : (item.name || item.finish || '');
        return { value: val, label: val };
      })
    : [];
  const groupOpt = group
    ? group.map((item) => {
        const val = typeof item === 'string' ? item : (item.name || item.product_typ_group || '');
        return { value: val, label: val };
      })
    : [];
  const spareOpt = spare
    ? spare.map((item) => {
        const val = typeof item === 'string' ? item : (item.name || item.spare_fg || '');
        return { value: val, label: val };
      })
    : [];


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  return (
    <>
      {getStatus === 'pending' && <Loader />}

      <UserTopbar heading="Draft" sidebar={isSidebarOpen} />
      <div className="  p-2 shadow-xl mx-auto">
        <Box
          className="bg-gray-900/90 p-3"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTopRightRadius: 10,
            borderTopLeftRadius: 10,
            borderColor: "#fff",
          }}
        >
          <div className="w-full sm:w-[220px]">
            <Select
              options={brandOpt}
              value={selectedBrand}
              onChange={setSelectedBrand}
              placeholder="Select Brand"
              styles={customStyles}
            />
          </div>

          <div className="w-full sm:w-[220px]">
            <Select
              options={finishOpt}
              value={selectedFinish}
              onChange={setSelectedFinish}
              placeholder="Select Finish"
              styles={customStyles}
            />
          </div>

          <div className="w-full sm:w-[220px]">
            <Select
              options={spareOpt}
              value={selectedSpare}
              onChange={setSelectedSpare}
              placeholder="Select Spare FG"
              styles={customStyles}
            />
          </div>

          <div className="w-full sm:w-[220px]">
            <Select
              options={groupOpt}
              value={selectedGroup}
              onChange={setSelectedGroup}
              placeholder="Select Group"
              styles={customStyles}
            />
          </div>

          {/* --- ROW 2 ITEMS --- */}
          <div className="w-full sm:w-[220px]">
            <Select
              options={collectionOpt}
              value={selectedCollection}
              onChange={setSelectedCollection}
              placeholder="Select Collection"
              styles={customStyles}
            />
          </div>


          <div className="relative">
            <input
              type="text"
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by SKU Code, Description..."
              className="p-[6px] w-[20rem] border-2 border-teal-800 rounded-md text-black transition duration-200"
              required
            />
            <span className="absolute inset-y-0 right-0 flex items-center pr-3">
              <FaSearch className="text-teal-800" />
            </span>
          </div>
        </Box>

        <div className="rounded-sm shadow-lg overflow-x-auto">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {["Sr No", "HSN Code", "SKU Code", "Brand", "Product Description", "Finish", "MRP", "Image", "GST", "Category", "Price Segment", "Product Type Group", "Collection"].map((header) => (
                    <TableCell
                      key={header}
                      className="bg-gray-900/90"
                      style={{ color: "#fff", fontWeight: "bold" }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody className="bg-white/80">
                {adminProducts.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={13} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                ) : (
                  adminProducts.map((item, index) => (
                    <TableRow key={item.id} sx={{ p: 0 }}>
                      <TableCell align="center">
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell align="center">{item.hsnCode}</TableCell>
                      <TableCell align="center">{item.sku_code}</TableCell>
                      <TableCell align="center">{item.brand}</TableCell>
                      <TableCell align="center">{item.product_desc}</TableCell>
                      <TableCell align="center">{item.finish}</TableCell>
                      <TableCell align="center">{item.mrp}</TableCell>
                      <TableCell align="center">
                        <img
                          src={
                            item.image
                              ? item.image.startsWith("data:")
                                ? item.image
                                : item.image.startsWith("http://") || item.image.startsWith("https://")
                                  ? (item.updated_at ? `${item.image}?v=${item.updated_at}` : item.image)
                                  : `${Apiurl.replace('/api/', '')}${item.image.startsWith('/') ? '' : '/'}${item.image}${item.updated_at ? `?v=${item.updated_at}` : ''}`
                              : fallbackImg
                          }
                          alt={item.sku_code || "Product"}
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "contain",
                            margin: "auto",
                            display: "block",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = fallbackImg;
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">{item.gst}</TableCell>
                      <TableCell align="center">{item.category}</TableCell>
                      <TableCell align="center">{item.priceSegment}</TableCell>
                      {/* <TableCell align="center">{item.spare_fg}</TableCell> */}
                      <TableCell align="center">
                        {item.product_typ_group}
                      </TableCell>
                      <TableCell align="center">{item.collection}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            sx={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
            rowsPerPageOptions={[10, 50, 100, 500, counts]}
            component="div"
            count={counts}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default UserProducts;

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderColor: state.isFocused ? "#0288d1 !important" : "#c4c4c4",
    boxShadow: state.isFocused ? "0 0 0 1px #0288d1" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#0288d1" : "#a0a0a0",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  placeholder: (base) => ({
    ...base,
    color: "#a0a0a0",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};